/* ============ OSO shared product data + photo renderer ============
   Two designs (the bear mark and the OSO wordmark), five colourways each.
   Every tile on the site goes through shopTee(), so the whole catalogue is
   driven from the tables below. */

/* [hex, marketing name, folder key], hex is only ever used for swatches */
window.OSO_COLORS=[
  ['#f0e6d4','Cozy','cozy'],
  ['#f6cbc7','Salmon','salmon'],
  ['#4a2e24','Grizzly','grizzly'],
  ['#28344a','River','river'],
  ['#141414','Night','night']
];
window.OSO_SIZES=[['XS',1],['S',1],['M',1],['L',1],['XL',1]];

/* ============================ stock ============================
   From the inventory sheet: 56 stocked variants, 811 pieces.
   product id -> colour key -> size -> units on hand. A size absent from a
   colourway was never cut in it (Bear Tee in Night is only M and XL); a 0 means
   it sold out. Sheet colour names map onto the site's: BROWN=Grizzly,
   NAVY=River, BLACK=Night, PINK=Salmon, OFF WHITE=Cozy.

   On the Shopify store this table is only the fallback — oso-variants.liquid
   emits OSO_SHOPIFY_STOCK from Shopify's own variant availability, so the
   storefront follows real stock as orders come in. Keep this in step with
   Shopify by hand, or it will go stale the first time something sells out. */
window.OSO_STOCK={
  'bear-tee':{
    night:  {M:25, XL:9},                          /* only two sizes were cut */
    grizzly:{XS:9,  S:7,  M:13, L:11, XL:7},
    river:  {XS:9,  S:25, M:27, L:22, XL:9},
    cozy:   {XS:10, S:13, M:11, L:7,  XL:3},
    salmon: {XS:21, S:24, M:19, L:26, XL:8}
  },
  'signature-tee':{
    night:  {XS:8,  S:20, M:2,  L:22},             /* no XL in this colourway */
    grizzly:{XS:10, S:5,  M:10, L:11, XL:8},
    river:  {XS:9,  S:23, M:29, L:22, XL:9},
    cozy:   {XS:9,  S:12, M:10, L:4,  XL:4},
    salmon: {XS:18, S:24, M:18, L:23, XL:9}
  },
  'vibe-tee':{
    grizzly:{XS:18, S:30, M:25, L:18, XL:3},
    cozy:   {XS:14, S:25, M:26, L:15, XL:3}
  }
};

/* Units on hand for one variant. Shopify's live answer wins where we have it —
   there it is boolean, so treat the number as meaningful only off the store. */
window.OSO_stockOf=function(pid,ck,size){
  const live=window.OSO_SHOPIFY_STOCK&&window.OSO_SHOPIFY_STOCK[pid];
  if(live){
    const cn=OSO_colorByKey(ck)[1];
    return live[cn+'|'+size]?1:0;
  }
  const c=((window.OSO_STOCK||{})[pid]||{})[ck];
  return (c&&c[size])||0;
};
/* [size, units] for every size, in shop order — 0 units means show it sold out */
window.OSO_sizesFor=(pid,ck)=>OSO_SIZES.map(z=>[z[0],OSO_stockOf(pid,ck,z[0])]);
/* is this colourway buyable in any size at all */
window.OSO_colorInStock=(pid,ck)=>OSO_SIZES.some(z=>OSO_stockOf(pid,ck,z[0])>0);
/* the size to preselect: M when it is there, else the first one that is */
window.OSO_defaultSize=function(pid,ck){
  const a=OSO_sizesFor(pid,ck).filter(s=>s[1]>0);
  if(!a.length) return '';
  const m=a.find(s=>s[0]==='M');
  return (m||a[0])[0];
};
window.OSO_colorKey=hex=>{const c=OSO_COLORS.find(x=>x[0]===hex);return c?c[2]:OSO_LEGACY_HEX[hex]||'cozy';};
window.OSO_colorName=hex=>{const c=OSO_COLORS.find(x=>x[0]===hex);return c?c[1]:'Cozy';};
window.OSO_colorByKey=k=>OSO_COLORS.find(x=>x[2]===k)||OSO_COLORS[0];
/* swatch hexes changed when the real photography landed, keep old links working */
window.OSO_LEGACY_HEX={'#eae8df':'cozy','#edb4b4':'salmon','#563e38':'grizzly','#567ea2':'river','#2f455b':'night','#dbbba4':'cozy'};

/* the shades a given design is actually made in (the Vibe Tee is a two-shade run) */
window.OSO_productColors=p=>OSO_COLORS.filter(c=>!p.colors||p.colors.indexOf(c[2])>=0);

/* gallery entries are [file stem, thumbnail label] */
window.OSO_PRODUCTS=[
  {id:'bear-tee', name:'Bear Tee', print:'bear', dir:'bear', badge:'Bestseller', price:1900,
   color:'#141414', cn:'Night',
   blurb:'The bear, chest-left',
   desc:'The tee that started OSO. Our signature bear sits quietly on the chest, embroidered on 100% Supima® cotton. Made to be the one you reach for without thinking.',
   gallery:{
     cozy:   [['cozy-model','The fit'],['cozy-chest','The detail'],['cozy-sleeve','Sleeve'],['stack','The range']],
     salmon: [['salmon-model','The fit'],['salmon-back','Back'],['salmon-shoulder','Shoulder'],['salmon-sleeve','Sleeve']],
     grizzly:[['grizzly-model','The fit'],['stack','The range']],
     river:  [['river-model','The fit'],['stack','The range']],
     night:  [['night-model','The fit'],['stack','The range']]
   }},
  {id:'signature-tee', name:'Signature Tee', print:'word', dir:'word', badge:'', price:1900,
   color:'#4a2e24', cn:'Grizzly',
   blurb:'OSO, front and centre',
   desc:'The OSO wordmark is embroidered across the chest on soft, substantial Supima® cotton. A clean everyday tee with just enough character to stand on its own. Made to be worn over and over again.',
   gallery:{
     cozy:   [['cozy-model','The fit'],['cozy-model2','The fit'],['cozy-chest','The mark'],['cozy-sleeve','Sleeve'],['cozy-sleeve2','Detail'],['cozy-flat','The fabric']],
     salmon: [['salmon-model','The fit']],
     grizzly:[['grizzly-model','The fit'],['grizzly-chest','The mark'],['grizzly-chest2','Detail'],['grizzly-sleeve','Sleeve']],
     river:  [['river-model','The fit'],['river-chest','The mark'],['river-flat','The fabric']],
     night:  [['night-model','The fit'],['night-model2','The fit'],['night-chest','The mark']]
   }},
  {id:'vibe-tee', name:'Vibe Tee', print:'mini', dir:'vibe', badge:'New', price:1900,
   color:'#f0e6d4', cn:'Cozy',
   /* this design is only made in two shades */
   colors:['cozy','grizzly'],
   blurb:'The bear and his records',
   desc:'Oso with his favourite records, embroidered on the chest. Made for days spent at your own pace. Cut from soft, substantial Supima® cotton in our relaxed, boxy unisex fit.',
   gallery:{
     cozy:   [['cozy-model','The fit'],['cozy-chest','The detail'],['cozy-flat','The fabric'],['pair','Both shades']],
     grizzly:[['grizzly-model','The fit'],['grizzly-chest','The detail'],['grizzly-flat','The fabric'],['pair','Both shades']]
   }}
];
window.OSO_findProduct=id=>window.OSO_PRODUCTS.find(p=>p.id===id)||window.OSO_PRODUCTS[0];
window.OSO_byPrint=print=>window.OSO_PRODUCTS.find(p=>p.print===print)||window.OSO_PRODUCTS[0];

/* every SKU on the site, in shop order */
window.OSO_VARIANTS=()=>OSO_PRODUCTS.flatMap(p=>OSO_productColors(p).map(c=>({p,hex:c[0],cn:c[1],ck:c[2]})));

/* ---- photo lookup ---- */
window.OSO_gallery=(p,ck)=>(p.gallery&&(p.gallery[ck]||p.gallery[OSO_colorKey(p.color)]))||[];
window.OSO_photo=function(p,ck,i,small){
  const g=OSO_gallery(p,ck); if(!g.length) return '';
  const stem=(g[i||0]||g[0])[0];
  return (window.OSO_ASSET||'')+'img_'+p.dir+'_'+stem+(small?'-sm':'')+'.webp';
};

/* The single choke point every tile renders through. `fill` may be a swatch hex
   or a colour key; `print` is 'bear' | 'word'. */
window.shopTee=function(fill,print,opts){
  opts=opts||{};
  const p=typeof print==='object'?print:OSO_byPrint(print);
  const ck=/^#/.test(fill)?OSO_colorKey(fill):(fill||'cozy');
  const src=OSO_photo(p,ck,opts.i||0,opts.small!==false);
  const alt=p.name+' in '+OSO_colorByKey(ck)[1];
  /* a design whose photography hasn't landed yet gets a designed tile, not a hole */
  if(!src) return '<div class="tee-img tee-missing"><span>'+p.name+'<b>Photography coming</b></span></div>';
  return '<img class="tee-img" src="'+src+'" alt="'+alt+'" loading="lazy" decoding="async">';
};
/* full-resolution variant for the big PDP frame */
window.shopTeeBig=function(fill,print,i){
  return window.shopTee(fill,print,{i:i||0,small:false}).replace('loading="lazy"','');
};

/* the little bear mark, still drawn as SVG where a logo (not a photo) is wanted */
window.bearMark=function(x,y,w,color){const L=window.OSO_LOGO;if(!L)return'';const vb=L.views.bear.split(' ').map(Number),h=w*vb[3]/vb[2];
  return `<svg x="${x}" y="${y}" width="${w}" height="${h}" viewBox="${L.views.bear}" style="overflow:visible"><g transform="${L.flip}"><g transform="translate(${L.bear.t[0]} ${L.bear.t[1]})"><path d="${L.bear.d}" fill="${color}"/></g><g transform="translate(${L.eye.t[0]} ${L.eye.t[1]})"><path d="${L.eye.d}" fill="${color}"/></g></g></svg>`;};
